import { render, staticRenderFns } from "./TaskPeriodization.vue?vue&type=template&id=3678f6d6&scoped=true&lang=pug"
import script from "./TaskPeriodization.vue?vue&type=script&lang=js"
export * from "./TaskPeriodization.vue?vue&type=script&lang=js"
import style0 from "./TaskPeriodization.vue?vue&type=style&index=0&id=3678f6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678f6d6",
  null
  
)

export default component.exports